"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_1 = (0, tslib_1.__importDefault)(require("./icons"));
const S = (0, tslib_1.__importStar)(require("./styles"));
const Icon = ({ icon, size = 38, color = '#000', className, hasFill = true, hasStroke = true, counter = null, }) => {
    const Icon = (0, react_1.useMemo)(() => icons_1.default[icon], [icon]);
    return ((0, jsx_runtime_1.jsxs)(S.Container, Object.assign({ "data-testid": "icon", color: color, size: size, className: className, hasFill: hasFill, hasStroke: hasStroke }, { children: [(0, jsx_runtime_1.jsx)(Icon, {}, void 0), counter ? (0, jsx_runtime_1.jsx)(S.Counter, Object.assign({ color: color }, { children: counter }), void 0) : null] }), void 0));
};
exports.default = Icon;
